import { UserOrganizationResponse } from "../../../api-models/response/user/UserResponse";
import { RowItemData } from "../../../components/datatable/interfaces";
import { translationService } from "../../translation/TranslationService";
import { EmploymentStatus } from "../EmploymentStatus";
import { Role } from "../Role";
import { DemoTag, EnterpriseTag } from "../../../components/grid-tag/Tags";

export class UserOrganization implements RowItemData {
  id: number;
  lockedInspectionsCount: number;
  hasPaidSubscription: boolean;
  name: string;
  subscriptionCancelationDate?: Date;
  roleId: number;
  private isDemo: boolean;
  private allowEnterprise: boolean;
  private role: string;
  private status: string;
  private email: string;
  private phone: string;
  private contactName: string;
  private employmentStatus: EmploymentStatus;

  constructor(userOrganizationResponse: UserOrganizationResponse) {
    this.id = userOrganizationResponse.organizationDetails.id;
    this.lockedInspectionsCount = userOrganizationResponse.lockedInspectionsCount;
    this.name = userOrganizationResponse.organizationDetails.name;
    this.status = userOrganizationResponse.organizationDetails.status.translationKey;
    this.email = userOrganizationResponse.organizationDetails.email;
    this.phone = userOrganizationResponse.organizationDetails.phone;
    this.contactName = userOrganizationResponse.organizationDetails.contact.name;
    this.role = new Role(userOrganizationResponse.role).translationKey;
    this.roleId = userOrganizationResponse.role.id;
    this.employmentStatus = new EmploymentStatus(userOrganizationResponse.employmentStatus);
    this.hasPaidSubscription = userOrganizationResponse.organizationDetails.hasPaidSubscription;
    this.subscriptionCancelationDate = userOrganizationResponse.subscriptionCancelationDate;
    this.isDemo = userOrganizationResponse.organizationDetails.isDemo;
    this.allowEnterprise = userOrganizationResponse.organizationDetails.allowEnterprise;
  }

  get displayValues() {
    return {
      name: {
        toDisplay: this.name,
        child: this.allowEnterprise ? EnterpriseTag : this.isDemo ? DemoTag : null,
      },
      status: { toDisplay: translationService.translate(this.status) },
      email: { toDisplay: this.email },
      phone: { toDisplay: this.phone },
      contact: { toDisplay: this.contactName },
      role: {
        toDisplay: translationService.translate(this.role),
      },
      employmentStatus: {
        toDisplay: this.employmentStatus.displayName,
      },
    };
  }
}
